import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { toCamelCase } from "utils/Utils";
import { formatAmount } from "utils/Utils";
import { parseDateMDY } from "utils/Utils";

const IncomeDetailsReview = ({ classes, incomeDetails, userLeadIdDetails, adhaarDetails }) => {
  const itemView = (label, value) => {
    return (
      <Grid item xs={12} sm={6} md={3} className={classes.fieldContainer}>
        <p style={{ marginBottom: 0 }}>
          <b>{label}</b>
        </p>
        <label>{value}</label>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} className={classes.inputFieldContainer}>
        <h2 className={classes.header} style={{ fontSize: "1.5rem" }}>
          Income Details
        </h2>
      </Grid>

      <Grid item xs={12} container spacing={2} alignItems="center">
        <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
          <Grid container className={classes.inputFieldContainer}>
            {itemView("Employment Type",toCamelCase(incomeDetails?.employmentType) || "NA")}
            {itemView("Monthly Income", formatAmount(incomeDetails?.monthlyIncome) || "NA")}
            {itemView("Pan Number", incomeDetails?.panNumber || "NA")}
            {itemView("Adhaar Number", adhaarDetails?.adhaarNumber || "NA")}
            {itemView("PFUan", incomeDetails?.pfUan || "NA")}
            {itemView("D.O.B",parseDateMDY(incomeDetails?.dob) || "NA")}
            {itemView("Mobile Number", userLeadIdDetails?.mobile_number || "NA")}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

IncomeDetailsReview.propTypes = {
  classes: PropTypes.object,
  incomeDetails: PropTypes.object,
};

export default IncomeDetailsReview;
